import { TdsDropdown, TdsDropdownOption } from "@scania/tegel-react"
import { debounce } from "lodash"
import type { JSX } from "@scania/tegel";
import { Controller, useFormContext } from "react-hook-form";
import { useEffect } from "react";

type listItem = {
    name: string,
    value: string
}

interface GenericDropdownParams extends JSX.TdsDropdown {
    onDropdownChange?: (value: string) => void,
    listData?: Array<listItem>
    dataFieldName: string
    required?: string
    className?: string
}

const GenericDropdown = (params: GenericDropdownParams) => {
    const { onDropdownChange, listData, dataFieldName, required, defaultValue } = params;
    const { setValue, getValues, register, setError, clearErrors, unregister, control } = useFormContext();
    const selectValue = defaultValue || getValues(dataFieldName)

    const onTdsChange = (e: TdsDropdownEvent) => {
        if (e.detail.value) {
            setValue(dataFieldName, e.detail.value)
            clearErrors(dataFieldName);
            onDropdownChange ? onDropdownChange(e.detail.value) : console.log(e.detail.value);
        } else {
            e.preventDefault();
            e.stopPropagation()
            e.stopImmediatePropagation();
        }
        if (e.detail.value === '') {
            setError(dataFieldName, { message: required, type: "required" }, { shouldFocus: true })
        }
    }
    useEffect(() => {
        register(dataFieldName, { required: required })
        return () => {
            unregister(dataFieldName);
        }
    // eslint-disable-next-line   
    },[])

    return (
        <Controller
            name={dataFieldName}
            control={control}
            render={({ field: { onBlur }, fieldState: { error } }) => (
                <TdsDropdown {...params}
                    onTdsChange={debounce((onTdsChange), 300)}
                    defaultValue={selectValue}
                    error={error?.type === 'required'}
                    onBlur={onBlur}
                >
                    {listData && listData.map((item) => (
                        <TdsDropdownOption value={item.value} className="confirm-dialog">{item.name}</TdsDropdownOption>
                    ))}
                </TdsDropdown>

            )}
        />
    )
}
export default GenericDropdown